var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPigogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.95679 18.2956H9.94133C9.94133 19.9884 8.56907 21.3606 6.8763 21.3606H5.95679V18.2956Z",
    fill: "#E9688A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4429 9.10046C19.4429 12.8246 16.424 15.8435 12.6999 15.8435C11.7171 15.8435 10.7834 15.6333 9.94133 15.2553V17.6826H5.95679V9.10046C5.95679 5.37637 8.97576 2.35739 12.6999 2.35739C16.424 2.35739 19.4429 5.37637 19.4429 9.10046ZM9.02182 9.10046C9.02182 7.24156 10.666 5.72893 12.6938 5.72893C14.7216 5.72893 16.3779 7.24156 16.3779 9.10046C16.3779 10.9594 14.7216 12.472 12.6938 12.472C10.666 12.472 9.02182 10.9578 9.02182 9.10046Z",
    fill: "#313D53"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPigogo);
export default __webpack_public_path__ + "static/media/pigogo.f884c5ce6593469913755eb2426bafec.svg";
export { ForwardRef as ReactComponent };